<tiime-input-container
  tiimeFormInputContainer
  [contentId]="contentId"
  [small]="small"
  [fixedLabel]="fixedLabel"
  [label]="label"
  [errorMessage]="errorMessageMode === 'label' && errorMessage?.message"
  [required]="required"
>
  <tiime-select
    [multiple]="multiple"
    [id]="contentId"
    [formControl]="control"
    (selectionChange)="emitSelectionChange($event)"
  >
    <div tiimeSelectOptions>
      @if (allowEmptyOption) {
        <mat-option [value]="null">{{ emptyOptionLabel }}</mat-option>
      }
      @for (option of options; track option.code) {
        <mat-option [value]="option.code">
          {{ option.label }}
        </mat-option>
      }
    </div>
    <ng-content tiimeSelectSuffix select="[tiimeSelectSuffix]" />
  </tiime-select>
</tiime-input-container>
@if (errorMessageMode === 'list' && errorMessage) {
  <app-list-error [errorMessage]="errorMessage"></app-list-error>
}
